<template>
  <div class="code-engagement-wrap pt-20 pb-20">
    <div class="container mx-auto px-4">
      <h2 class="text-3xl font-bold text-center mb-8 text-gray-800">
        Code d’engagement
      </h2>

      <div class="prose max-w-4xl mx-auto text-justify leading-relaxed text-gray-800">
        <p class="italic text-center text-lg mb-6">
          « EITP EN MISSION » : PROJET D’UN CODE D’ENGAGEMENT
        </p>

        <blockquote class="border-l-4 border-yellow-500 pl-4 italic text-gray-700 mb-6">
          Qui sème chichement moissonnera aussi chichement; qui sème largement moissonnera aussi largement.
          Que chacun donne selon ce qu’il a décidé dans son cœur, non d’une manière chagrine ou contrainte;
          car Dieu aime celui qui donne avec joie. Dieu d’ailleurs est assez puissant pour vous combler de
          toutes sortes de libéralités afin que, possédant toujours et en toute chose tout ce qu’il vous faut,
          il vous reste du superflu pour toute bonne œuvre.
          <br />
          <span class="font-semibold">2 Corinthiens 9, 6-8</span>
        </blockquote>

        <p>
          Les différents axes de l’EITP en mission (en famille et dans les milieux socio-professionnels, en paroisse
          et dans les groupes ou associations, à l’EITP et sous l’égide de l’EITP) constituent des axes du même engagement
          volontaire, en cohérence avec la formation reçue et l’envoi en mission y afférente.
        </p>

        <p>
          Les divers pôles d’engagement relatifs à l’EITP (Services, Soutiens, Animation) relèvent tous du bénévolat
          et ont tous même valeur. Les moyens que nécessitent certains services seront mis à disposition par l’EITP.
        </p>

        <p>
          Les diverses missions de l’EITP en mission, selon leur nature, impliquent une bonne préparation a priori disponible
          et aussi le renforcement des capacités par une formation permanente d’assimilation.
        </p>

        <p>
          L’Engagement à l’EITP en mission est absolument libre : le disciple d’Emmaüs qui s’engage ne doit absolument se sentir
          tenu par aucune contrainte. Il peut, sans scrupule, réorganiser ses temps de disponibilité et même suspendre pour un
          temps ou définitivement son engagement, prenant soin d’aviser au préalable.
        </p>

        <p>
          L’Engagement à l’EITP en mission est fondamentalement responsable. Ces missions, expression du témoignage de foi et
          mode de représentation de l’EITP, requièrent pour leur efficacité selon leur nature, une conscience droite, une
          posture cohérente, et un sens ecclésial raffiné (à travers la fidélité à la doctrine de l’Église et non des vues
          personnelles ou relatives à un groupe déterminé).
        </p>

        <p>
          L’engagement à l’EITP, au-delà des sacrifices inhérents à tout engagement et des possibles limites de chacun, doit être
          porté par la joie de la foi.
        </p>

        <p>
          À l’EITP en mission, le disciple qui s’engage n’est ni figurant ni spectateur, mais actif et acteur. Les engagements
          relatifs à l’École, non assumés sur une certaine période, après échange, sont suspendus.
        </p>

        <blockquote class="border-l-4 border-yellow-500 pl-4 italic text-gray-700 mt-8">
          En retour mon Dieu comblera tous vos besoins, selon sa richesse, avec magnificence, dans le Christ Jésus.
          Gloire à ce Dieu, notre Père, dans les siècles des siècles ! Amen.
          <br />
          <span class="font-semibold">Philippiens 4, 19</span>
        </blockquote>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CodeEngagement",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.code-engagement-wrap {
  background-color: #fdfdfd;
}

.prose p {
  margin-bottom: 1rem;
}

blockquote {
  background-color: #fff9db;
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;
}
</style>
